import { Component, Input, SimpleChanges, } from '@angular/core';

@Component({
    selector: 'app-pdf-reader',
    templateUrl: './pdf-reader.component.html',
    styleUrls: ['./pdf-reader.component.scss'],
    standalone: false
})
export class PdfReaderComponent {
  //#region properties

  @Input('src') input_src: string;
  @Input('imgHeight') input_imgHeight: string = '108px';
  @Input('imgWidth') input_imgWidth: string = '100%';
  @Input('imgStyle') input_style: string;

  //#endregion

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {

  }

}
